export default __webpack_public_path__ + "static/escritorioGoiania-d24d5792fad172e6233f6d56fad2f29b.jpg";